import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Services from "../common/Services";
import Headerstart from "../common/Headerstart";

const ServicesPage = () => {
  return (
    <>
      <Header />
      <Headerstart link={"Services"} />
      <Services />
      <Footer />
    </>
  );
};

export default ServicesPage;
